var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"radial-gradient(216.41% 100% at 50% 100%, #FFFFFF 0%, #FFF4EC 44.01%, #FFD5C0 56.72%, #FFE0BA 84.59%, #FFAF79 100%)"}})}
var staticRenderFns = []

export { render, staticRenderFns }